import { createTheme } from '@mui/material/styles';

// Custom palette keys:
// - accent: app chrome (AppBar, floating search button, search button).
// - rowHover: hover highlight for list rows, index letters and outlined buttons.
const lightPalette = {
  mode: 'light',
  background: { default: '#fdfde8', paper: '#ffffff' },
  accent: { main: '#000000', contrastText: '#ffffff' },
  rowHover: '#f0f0dc'
};

// Dark values follow the armenian-hymns and arm-bible apps so they all look alike in dark mode.
const darkPalette = {
  mode: 'dark',
  background: { default: '#202124', paper: '#2c2c2c' },
  text: { primary: '#e8eaed', secondary: '#9aa0a6' },
  accent: { main: '#3c4043', contrastText: '#ffffff' },
  rowHover: '#333333'
};

export function getTheme(mode) {
  return createTheme({ palette: mode === 'dark' ? darkPalette : lightPalette });
}
